import Header from "../components/Header"
import CuisineStrip from "../components/CuisineStrip"
import Footer from "../components/Footer"

export default function Home(){

    return (
        <>
         <Header></Header>
         <CuisineStrip></CuisineStrip>
         <Footer></Footer>
        </>
    )
}